const Stats = () => <div>Stats</div>

export default Stats;
